import { isGameProviderRoute } from '@infinitro/catalog-min/providers';

export const match = (param: string): boolean => {
	return isGameProviderRoute(param);
};
